<template>
  <d-container fluid>
    <d-form @submit.prevent="submit">
      <d-row>
        <d-col sm="12" md="12" lg="12">
          <d-card>
            <h3 class="table-title mb-0 p-3">
              Classificação de risco Vibração
            </h3>
            <d-tabs class="custom-tabs">
              <d-tab
                title="NHO 09 – Vibração de corpo inteiro"
                :active="selectedRiskModel === 'nho09'"
                class="p-0"
              >
                <vibration-classification-table
                  :model.sync="model.vibration.nho09"
                  :criteria="model.vibration.nho09.criteria"
                />
              </d-tab>
              <d-tab
                title="NHO 10 – Vibração de mãos e braços"
                :active="selectedRiskModel === 'nho10'"
                class="p-0"
              >
                <vibration-classification-table
                  :model.sync="model.vibration.nho10"
                  :criteria="model.vibration.nho10.criteria"
                />
              </d-tab>
            </d-tabs>
          </d-card>
        </d-col>
      </d-row>

      <d-form-row class="mt-4">
        <d-button class="btn-primary" type="submit">
          Salvar
        </d-button>
      </d-form-row>
    </d-form>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import SettingsService from '_services/rest/modules/settings';
import formatErrors from '_common/mixins/FormatErrors';
import VibrationClassificationTable from './ClassificationTables/VibrationClassificationTable.vue';
import { _LOAD_MODEL_RISK_CLASSIFICATIONS_, RISK_CLASSIFICATIONS } from './SettingsModel';

export default {
  name: 'result-form',
  mixins: [formatErrors],
  components: {
    VibrationClassificationTable,
  },
  data() {
    return {
      model: { ...RISK_CLASSIFICATIONS },
      selectedRiskModel: 'nho',
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    checkForm() {
      return this.checkRiskClassificationFields();
    },
    checkRiskClassificationFields() {
      const classifications = this.model.riskClassification;
      const fields = ['min', 'max'];

      const numberRegex = /^\d*[.,]?\d+$/;

      return Object.values(classifications).some(classification =>
        Object.values(classification.levels).some(level =>
          fields.some(field =>
            level[field] &&
            Object.values(level[field]).some(value => value !== null && !numberRegex.test(value)))));
    },
    submit() {
      this.loading = true;

      try {
        SettingsService.saveOptions(this.model, 'riskClassification')
          .then(() => {
            this.getSettings();
            this.activeAlert({
              message: 'Classificação de risco salva com sucesso',
              theme: 'success',
            });
          });
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_RISK_CLASSIFICATIONS_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss">
.table-title {
  font-size: 16px;
  font-weight: bold;
  color: #424242;
}

.custom-tabs .nav-tabs {
  padding-left: 10px;
}

.custom-tabs .nav-tabs .nav-item .active {
  background-color: #F6F6F6;
}
</style>
